<template>
  <section class="layout-auth hero is-primary is-fullheight">
    <!-- Hero head: will stick at the top -->
    <div class="hero-head">
      <nav class="navbar is-primary">
        <div id="navbarMenuHeroA" class="navbar-menu is-active">
          <div class="navbar-start">
            <a class="navbar-item" :href="localePath('index')">
              <img src="~/assets/images/logo.png" alt="logo" />
            </a>
          </div>
          <div class="navbar-end" v-if="showLangOptions">
            <nuxt-link
              v-for="locale in this.$i18n.locales"
              :key="locale.code"
              :to="switchLocalePath(locale.code)"
              class="navbar-item"
              :class="{'is-active': $i18n.locale == locale.code}"
              exact
            >{{ locale.name }}</nuxt-link>
          </div>
        </div>
      </nav>
    </div>
    <div class="hero-body">
      <div class="container">
        <nuxt />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  computed: {
    showLangOptions() {
      const routeName = this.getRouteBaseName();
      return routeName !== 'register';
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/index.scss";
@import "@/assets/scss/materialdesignicons/materialdesignicons.scss";
</style>


// WEBPACK FOOTER //
// resources/nuxt/layouts/auth.vue